"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var de = {
  'contractSelectorMessages.contractDetails': 'Vertragsdetails',
  'contractSelectorMessages.discount': 'Ermäßigung',
  'contractSelectorMessages.items': 'Artikel',
  'contractSelectorMessages.lastModified': 'Letzte Änderung',
  'contractSelectorMessages.lastModifiedBy': 'Letzte Änderung durch',
  'contractSelectorMessages.markup': 'Aufschlag',
  'contractSelectorMessages.revision': 'Version',
  'createOptionStep.contractNamePlaceholder': 'z. B. Katalogpreisbedingung mit {name}',
  'createOptionStep.header': 'Sie haben bereits Katalogpreisverträge mit {name} Fügen Sie die Produkte zu einem vorhandenen Vertrag hinzu oder erstellen Sie einen neuen',
  'createOptionStep.newOptionButtonDescription': 'Neuen Vertrag mit {name} erstellen',
  'createOptionStep.newOptionButtonTitle': 'Neuen Vertrag initiieren',
  'createOptionStep.updateExistingOptionButtonDescription': 'SKUs zu einem vorhandenen Vertrag mit {name} hinzufügen',
  'createOptionStep.updateExistingOptionButtonTitle': 'Vorhandenen Vertrag aktualisieren',
  'generalModal.backButtonText': 'Zurück',
  'generalModal.closeButtonText': 'Schließen',
  'generalModal.defaultErrorCreationMessage': 'Fehler beim Erstellen des Katalogpreisvertrags',
  'generalModal.financialFlowsSupport': 'Finanzströme – Support',
  'generalModal.forAssistanceText': 'zur Unterstützung',
  'generalModal.nextButtonText': 'Weiter',
  'generalModal.pleaseContactText': 'Kontaktieren Sie',
  'generalModal.termButtonCreatedStatus': 'Erstellt',
  'generalModal.termButtonCreatingStatus': 'Wird erstellt',
  'generalModal.termButtonDefaultText': 'Zur Genehmigung senden',
  'generalModal.title': 'Katalogpreisvertrag initiieren',
  'generalModal.viewPendingContractText': 'Klicken Sie hier, um den ausstehenden Vertrag im Vertragsmanager anzuzeigen',
  'listPriceConfirmStep.allSkusHaveContractsErrorMessage': 'Alle SKUs weisen einen Katalogpreisvertrag zwischen {merchantName} und {fulfillerName} auf',
  'listPriceConfirmStep.buyer': 'Käufer',
  'listPriceConfirmStep.confirmContractDetails': 'Vertragsdetails bestätigen',
  'listPriceConfirmStep.discount': 'Ermäßigung',
  'listPriceConfirmStep.endDate': 'Enddatum',
  'listPriceConfirmStep.errorLoadingSkusMessage': 'Fehler beim Laden der SKUs',
  'listPriceConfirmStep.excludedSkus': 'Ausgeschlossen ({count})',
  'listPriceConfirmStep.includedSkus': 'SKUs ({count})',
  'listPriceConfirmStep.markup': 'Aufschlag',
  'listPriceConfirmStep.name': 'Name',
  'listPriceConfirmStep.noEndDate': 'Kein Enddatum',
  'listPriceConfirmStep.seller': 'Verkäufer',
  'listPriceConfirmStep.skusHaveContractsWarning': 'Für diese SKUs existiert bereits ein Katalogpreisvertrag zwischen {fulfillerName} und {merchantName}',
  'listPriceConfirmStep.startDate': 'Startdatum',
  'listPriceCreateStep.existingHeader': 'Aus Katalogverträgen mit {name} wählen',
  'listPriceCreateStep.newHeader': 'Vertrag benennen',
  'listPriceInitiatorButton.listPriceInitiatorButtonText': 'Vertrag initiieren',
  'listPriceInitiatorButton.noIdentityMessage': 'Sie haben keine Händleridentität, um diese Aktion auszuführen',
  'listPriceInitiatorButton.noSkusSelectedMessage': 'Vor dem Erstellen eines Vertrags müssen gültige SKUs ausgewählt werden',
  'listPriceInitiatorButton.tooltipMessage': '{message}. Wenden Sie sich bei Fragen an {email}',
  'selectMerchantStep.header': 'Den Händler auswählen, der Produkte kauft',
  'selectMerchantStep.merchantSelectLabel': 'Händler',
  'skuSelector.apiErrorTemplate': 'Fehler während {serviceComment}. (Antwortcode: {status})',
  'skuSelector.apiSceneServiceComment': 'Szenen-URI wird abgerufen',
  'skuSelector.apiSkuServiceComment': 'SKUs werden gesucht',
  'skuSelector.csvDownloadLink': '{number} SKUs insgesamt (Hier klicken, um CSV herunterzuladen)',
  'skuSelector.csvDownloadName': 'all_skus.csv',
  'skuSelector.currentlyViewingText': 'Wird derzeit angezeigt',
  'skuSelector.descriptionFilterLabel': 'Beschreibung',
  'skuSelector.emptyBinPlaceholder': 'Suchen Sie nach Produkten anhand ihres Namens oder ihrer SKU und fügen Sie sie hier hinzu.',
  'skuSelector.filterOptionsTitle': 'Filteroptionen',
  'skuSelector.nameFilterLabel': 'Name',
  'skuSelector.removeSkuButtonText': 'SKUs entfernen',
  'skuSelector.searchFilterLabel': 'Nach Schlüsselwort filtern...',
  'skuSelector.skuBinNoFilterResult': "Keine Ergebnisse gefunden für '{filter}'.",
  'skuSelector.skuCardDisabledTooltip': 'Die Auswahl ist derzeit deaktiviert. Dieses Produkt kann nicht zu Ihrer Liste hinzugefügt oder davon entfernt werden.',
  'skuSelector.skuCountText': 'von {totalCount} SKUs',
  'skuSelector.skuFilterLabel': 'Sku',
  'skuSelector.skuSearchAddSkuButtonText': 'SKUs hinzufügen',
  'skuSelector.skuSearchAddSkuPrompt': 'Möchten Sie mehrere SKUs gleichzeitig hinzufügen?',
  'skuSelector.skuSearchBarHelpText': 'Beginnen Sie oben mit der Eingabe, um nach Produkten zu suchen',
  'skuSelector.skuSearchBarLabel': 'Geben Sie einen Produktnamen oder eine SKU ein',
  'skuSelector.skuSearchDefaultErrorMessage': 'Ein Fehler ist aufgetreten',
  'skuSelector.skuSearchDetailedErrorMessage': '{error}. Bitte versuchen Sie es erneut.',
  'skuSelector.skuSearchNextButtonText': 'Weiter',
  'skuSelector.skuSearchNotFoundErrorMessage': 'Keine Produkte gefunden für {query}',
  'skuSelector.skuSearchPrevButtonText': 'Zurück',
  'skuSelector.uploadModalAddButtonText': 'Hinzufügen ({totalCount})',
  'skuSelector.uploadModalAddError': 'Die oben genannten SKUs konnten nicht hinzugefügt werden, weil sie in der Plattform nicht vorhanden sind.  Sie können Rechtschreibfehler enthalten, z. B. nicht-alphanumerische Zeichen oder falsche Großbuchstaben. Bitte prüfen Sie die Angaben und versuchen Sie es erneut.',
  'skuSelector.uploadModalAddTitle': 'SKUs hinzufügen',
  'skuSelector.uploadModalCloseButtonText': 'Schließen',
  'skuSelector.uploadModalHelpText': 'Geben Sie eine Liste von durch Leerzeichen getrennten SKUs ein. Die gleichzeitige Verarbeitung Tausender SKUs kann einige Zeit dauern. Wenn erhebliche Verzögerungen auftreten, versuchen Sie es mit mehreren kleineren Uploads.',
  'skuSelector.uploadModalRemoveButtonText': 'Entfernen ({totalCount})',
  'skuSelector.uploadModalRemoveError': 'Die oben genannten SKUs konnten nicht entfernt werden, da sie als nicht entfernbar markiert sind.',
  'skuSelector.uploadModalRemoveTitle': 'SKUs entfernen',
  'skuSelector.uploadModalSkuLabel': 'SKUs',
  'skuSelector2.apiErrorTemplate': 'Fehler während {serviceComment}. (Antwortcode: {status})',
  'skuSelector2.apiSceneServiceComment': 'Szenen-URI wird abgerufen',
  'skuSelector2.apiSkuServiceComment': 'Suche nach Produkt-IDs',
  'skuSelector2.csvDownloadLink': '{number} Total Product Ids (Klicken Sie hier, um CSV herunterzuladen)',
  'skuSelector2.csvDownloadName': 'all_skus.csv',
  'skuSelector2.currentlyViewingText': 'Wird derzeit angezeigt',
  'skuSelector2.descriptionFilterLabel': 'Beschreibung',
  'skuSelector2.emptyBinPlaceholder': 'Search for products by their name or Product Id and add them here.',
  'skuSelector2.filterOptionsTitle': 'Filteroptionen',
  'skuSelector2.nameFilterLabel': 'Name',
  'skuSelector2.removeSkuButtonText': 'Produkt-IDs entfernen',
  'skuSelector2.searchFilterLabel': 'Nach Schlüsselwort filtern...',
  'skuSelector2.skuBinNoFilterResult': "Keine Ergebnisse gefunden für '{filter}'.",
  'skuSelector2.skuCardDisabledTooltip': 'Die Auswahl ist derzeit deaktiviert. Dieses Produkt kann nicht zu Ihrer Liste hinzugefügt oder davon entfernt werden.',
  'skuSelector2.skuCountText': 'aus {totalCount} Produkt-IDs',
  'skuSelector2.skuFilterLabel': 'Produkt ID',
  'skuSelector2.skuSearchAddSkuButtonText': 'Produkt-IDs hinzufügen',
  'skuSelector2.skuSearchAddSkuPrompt': 'Möchten Sie mehrere Produkt-IDs gleichzeitig hinzufügen?',
  'skuSelector2.skuSearchBarHelpText': 'Beginnen Sie oben mit der Eingabe, um nach Produkten zu suchen',
  'skuSelector2.skuSearchBarLabel': 'Geben Sie einen Produktnamen oder eine Produkt-ID ein',
  'skuSelector2.skuSearchDefaultErrorMessage': 'Ein Fehler ist aufgetreten',
  'skuSelector2.skuSearchDetailedErrorMessage': '{error}. Bitte versuchen Sie es erneut.',
  'skuSelector2.skuSearchNextButtonText': 'Weiter',
  'skuSelector2.skuSearchNotFoundErrorMessage': 'Keine Produkte gefunden für {query}',
  'skuSelector2.skuSearchPrevButtonText': 'Zurück',
  'skuSelector2.uploadModalAddButtonText': 'Hinzufügen ({totalCount})',
  'skuSelector2.uploadModalAddError': 'Die oben genannten Produkt-IDs konnten nicht hinzugefügt werden, da sie auf der Plattform nicht vorhanden sind. Sie können Tippfehler enthalten, z. B. nicht alphanumerische Zeichen oder falsche Groß- und Kleinschreibung. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
  'skuSelector2.uploadModalAddTitle': 'Produkt-IDs hinzufügen',
  'skuSelector2.uploadModalCloseButtonText': 'Schließen',
  'skuSelector2.uploadModalHelpText': 'Geben Sie eine Liste von Produkt-IDs ein, die durch Leerzeichen getrennt sind. Die gleichzeitige Verarbeitung von Tausenden von Produkt-IDs kann einige Zeit dauern. Wenn es zu erheblichen Verzögerungen kommt, versuchen Sie, mehrere kleinere Uploads durchzuführen.',
  'skuSelector2.uploadModalRemoveButtonText': 'Entfernen ({totalCount})',
  'skuSelector2.uploadModalRemoveError': 'Die oben genannten Produkt-IDs konnten nicht entfernt werden, da sie als nicht entfernbar markiert sind.',
  'skuSelector2.uploadModalRemoveTitle': 'Produkt-IDs entfernen',
  'skuSelector2.uploadModalSkuLabel': 'Produkt-IDs'
};
var _default = de;
exports.default = _default;